module.exports = __webpack_public_path__ + "img/istj.f8e55dbc.png";